<div style="margin: 1rem 0">
    <p *ngIf="metaData?.description" [innerHTML]="metaData?.description"></p>
    <p><button mat-button *ngIf="metaData?.valuesArray.length > 3" color="primary" (click)="onCheckAll()">Select All</button></p>
    <div [formGroup]="theForm" class="fieldWrapper" fxLayout="row wrap">
        <mat-checkbox
            fxFlex="1 1 50%"
            *ngFor="let checkbox of metaData?.valuesArray; let i = index"
            [formArrayName]="metaData?.inputName"
            (change)="onCheck($event, i)"
            [aria-label]="checkbox.name"
            [checked]="checkbox.checked"
            [value]="checkbox.value"
            color="primary"
            [disabled]="theForm.controls[this.metaData.inputName].at(i).status === 'DISABLED'"
            >{{ checkbox.name }}</mat-checkbox
        >
    </div>
</div>
